import { AppThunk } from 'store';
import {
  addBroadcast,
  setHeartLoading
} from 'features/broadcast/broadcastsSlice';
import { apiSendHeart } from 'api/hearts';
import { createAlert } from 'features/alert/alertSlice';
import { ConnectFunction, HubBroadcastStart } from 'features/hub/hub';
import { mapHubBroadcastStart } from './mappers';
import { updateEvent } from 'features/events/eventsSlice';

export const sendBroadcastHeart =
  (broadcastUID: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setHeartLoading(true));

      const response = await apiSendHeart(broadcastUID);
      if (response.status === 200) {
        setTimeout(() => {
          dispatch(setHeartLoading(false));
        }, 10000);
      }
    } catch (err) {
      dispatch(setHeartLoading(false));
      if (err?.status === 400) {
        const response = err as Response;
        const json = await response.json();
        dispatch(
          createAlert({
            message: json.error,
            type: 'error'
          })
        );
      }
    }
  };

export const handleBroadcastStartHubDisconnected =
  (broadcast: HubBroadcastStart, connectToSocket: ConnectFunction): AppThunk =>
  async (dispatch, getState) => {
    const {
      events: { events },
      hub: { isHubConnected }
    } = getState();
    const mappedBroadcast = mapHubBroadcastStart(broadcast);
    if (!mappedBroadcast.eventId) return;
    dispatch(addBroadcast(mappedBroadcast));
    const event = events[mappedBroadcast.eventId];
    const updatedEvent = { ...event, active: true };
    dispatch(updateEvent(updatedEvent));

    if (!isHubConnected) {
      connectToSocket();
    }
  };
